<template>
  <div class="flex-1 mx-4">
    <div
      v-if="IS_MOBILE_APP && showUsedProviderMessage"
      class="bg-white rounded-12 text-left mx-auto w-full max-w-lg shadow-2 p-4 mb-3"
    >
      <div class="flex justify-between items-baseline">
        <strong class="flex items-center">
          <svg role="presentation" focusable="false" tabindex="-1" class="icon-sm rounded-full text-white bg-green-800 mr-1"
             
            alt=""
            svg-inline
           xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
<path fill="currentColor" fill-rule="evenodd" d="m11.33 24-5-6.67a1.66 1.66 0 1 1 2.67-2l3.77 5.03 10.3-11.79a1.67 1.67 0 1 1 2.52 2.2L13.92 24.1c-.7.8-1.95.75-2.59-.1" clip-rule="evenodd"/>
</svg>
          {{ $t('transfer_comparison.in_your_provider_list') }}
        </strong>
        <NuxtLink to="/your-providers" class="link dark font-normal text-14">
          {{ $t('transfer_comparison.manage') }}
        </NuxtLink>
      </div>
      <p
        class="mt-4 text-14"
        v-html="
          $t('transfer_comparison.used_provider_message', {
            provider: groupedQuotes.psp.displayName,
          })
        "
      />
    </div>
    <button
      class="bg-white md:hover:bg-gray-50 rounded-12 flex items-center text-left mx-auto w-full max-w-lg shadow-2"
      @click="$emit('open-score')"
      :disabled="!groupedQuotes.psp.score"
    >
      <ScoreCircle
        :score="groupedQuotes.psp.score ? groupedQuotes.psp.score.value : undefined"
        size="sm"
        class="relative"
      />
      <div class="flex-1 mx-4 my-2 text-14">
        <p class="font-semibold">
          {{ $t('provider_score', { provider: groupedQuotes.psp.displayName }) }}
        </p>
        <p v-if="groupedQuotes.psp.score" class="underline">
          {{ $t('details') }}
        </p>
        <p v-else class="text-gray-600">
          {{ $t('no_score') }}
        </p>
      </div>
      <svg role="presentation" focusable="false" tabindex="-1" v-if="groupedQuotes.psp.score"
        class="mr-4 icon icon-sm -rotate-90"
         
        alt="open"
        svg-inline
       xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 19"><title>open</title>
  <path fill="currentColor" fill-rule="evenodd"
    d="M.8 1.18a2.26 2.26 0 0 1 3.2 0L16 13.2 28.03 1.18a2.26 2.26 0 0 1 3.2 3.2L17.6 17.97c-.88.9-2.31.9-3.2 0L.8 4.39a2.26 2.26 0 0 1 0-3.2Z"
    clip-rule="evenodd" />
</svg>
    </button>
    <button
      v-if="commonPromotion"
      class="bg-white md:hover:bg-gray-50 rounded-12 flex items-center text-left mx-auto w-full max-w-lg mt-3 shadow-2"
      @click="$emit('open-promo', commonPromotion)"
    >
      <span class="flex shrink-0 justify-center items-center w-20 h-20 p-1.5">
        <span class="rounded-full text-blue-900 bg-gray-50 p-4">
          <svg role="presentation" focusable="false" tabindex="-1" class="icon icon-lg"   alt="promotion" svg-inline  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32"><title>promotion</title>
<path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="m2.18 7.6 1.95 9.83 18.75 10.83 7.54-13.05L11.66 4.38 2.18 7.61Zm10.84 6.3a3.3 3.3 0 1 0-5.7-3.3 3.3 3.3 0 0 0 5.7 3.3Z"/>
<path fill="#fff" d="M19.58 19.41a1.82 1.82 0 0 1 1.83-.91 1.79 1.79 0 0 1 1.26.72c.15.2.25.41.3.65.07.23.1.46.06.7a1.79 1.79 0 0 1-.72 1.26 1.85 1.85 0 0 1-2.05.13 1.9 1.9 0 0 1-.56-.5 2.1 2.1 0 0 1-.31-.63 2.1 2.1 0 0 1-.06-.71c.04-.25.12-.48.25-.7Zm2.39 1.38a.87.87 0 0 0 .1-.68.87.87 0 0 0-.43-.54.87.87 0 0 0-.69-.1.87.87 0 0 0-.54.42.87.87 0 0 0-.1.69c.07.24.2.42.43.54.22.13.45.16.68.1.24-.06.42-.2.55-.43Zm-4.73-6.88a1.82 1.82 0 0 1 1.83-.92 1.79 1.79 0 0 1 1.26.73c.15.2.25.4.3.64.08.23.1.47.06.7a1.79 1.79 0 0 1-.72 1.26 1.85 1.85 0 0 1-2.05.13 1.9 1.9 0 0 1-.56-.49 2.1 2.1 0 0 1-.31-.64 2.1 2.1 0 0 1-.06-.71c.04-.24.12-.48.25-.7Zm2.39 1.38a.87.87 0 0 0 .1-.69.87.87 0 0 0-.43-.54.87.87 0 0 0-.69-.1.87.87 0 0 0-.54.43.87.87 0 0 0-.1.68c.07.24.2.42.43.55.22.12.45.15.68.1.24-.07.42-.21.55-.43Zm3.76-.21.52.74-7.27 4.28-.53-.75 7.28-4.27Z"/>
</svg>
        </span>
      </span>
      <p class="flex-1 mx-4 my-2 text-14 text-blue-900">
        <span
          v-html="$t(`promotions:${commonPromotion.headline}`, promoVariables)"
          v-if="promoVariables"
        />
        <span class="underline">{{ $t('details') }}</span>
      </p>
      <svg role="presentation" focusable="false" tabindex="-1" v-if="groupedQuotes.psp.score"
        class="mr-4 icon icon-sm -rotate-90"
         
        alt="open"
        svg-inline
       xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 19"><title>open</title>
  <path fill="currentColor" fill-rule="evenodd"
    d="M.8 1.18a2.26 2.26 0 0 1 3.2 0L16 13.2 28.03 1.18a2.26 2.26 0 0 1 3.2 3.2L17.6 17.97c-.88.9-2.31.9-3.2 0L.8 4.39a2.26 2.26 0 0 1 0-3.2Z"
    clip-rule="evenodd" />
</svg>
    </button>

    <MobileProviderLabels :grouped-quotes="groupedQuotes" />

    <ul class="mt-4 mb-28">
      <li v-for="(service, ind) in groupedQuotes.services" :key="service.amount" class="mb-4">
        <div
          v-if="
            ind === 0 || service.transferTime.id !== groupedQuotes.services[ind - 1].transferTime.id
          "
          class="relative font-semibold uppercase text-center mt-2 mb-4 -mx-4"
        >
          <hr class="absolute inset-x-0 top-1/2 border-t-2 border-dashed border-gray-300 -z-1" />
          <span class="bg-gray-50 px-2">
            <svg role="presentation" focusable="false" tabindex="-1" class="icon icon-sm"   alt="transfer time" svg-inline  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><title>transfer time</title>
<path fill="currentColor" d="M26.6,5.4a15,15,0,1,0,0,21.2A15,15,0,0,0,26.6,5.4ZM25.19,25.19a13,13,0,1,1,0-18.38A13,13,0,0,1,25.19,25.19Z"/>
<path fill="currentColor" d="M17,15.59V6a1,1,0,0,0-2,0V16a1.05,1.05,0,0,0,.29.71l4,4a1,1,0,0,0,1.42-1.42Z"/>
</svg>
            {{
              $t(`transfer_time.${service.transferTime.key}`, {
                count: service.transferTime.min,
                min: service.transferTime.min,
                max: service.transferTime.max,
              })
            }}
          </span>
        </div>
        <MobileProviderService
          :provider="groupedQuotes.psp"
          :service="service"
          :has-common-promo="commonPromotion !== null"
          :mid-market-rate="midMarketRate"
          :is-expanded="ind === 0"
          @open-promo="$emit('open-promo', $event)"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { GroupedQuotes, Promotion } from '../types'
import { getPromotionVariables } from '@core/components/provider-promotion/helpers/utils'
import MobileProviderLabels from './mobile-provider-labels.vue'
import MobileProviderService from './mobile-provider-service.vue'

const IS_MOBILE_APP = __IS_MOBILE_APP__

const props = defineProps<{
  groupedQuotes: GroupedQuotes
  commonPromotion: Promotion | null
  midMarketRate: number
}>()

defineEmits(['open-promo', 'open-score'])

const promoVariables = computed(() =>
  getPromotionVariables(props.commonPromotion, props.groupedQuotes.psp.displayName),
)

const usedProviders = ref<string[]>([])
onMounted(async () => {
  if (__IS_MOBILE_APP__) {
    usedProviders.value = await loadUsedProviders()
  }
})

const showUsedProviderMessage = computed(() => {
  return usedProviders.value.some((provider) => provider === props.groupedQuotes.psp.slug)
})
</script>
